<template>
    <table class="mg-table-market-data-interactive text-sm heading-font border-separate" v-if="data">
        <thead>
            <tr class="uppercase antialiased text-sm text-white tracking-medium border-b-0">
                <th class="border-b-0 hidden xl:table-cell md-chart-wrapper__label-cell"></th>
                <th class="border-b-0 font-normal p-0 xl:w-36 mg-banded-primary-darker" scope="col"><span class="block px-4 py-2">Previous Market Year ({{marketDataSettings.previous_market_year_label}})</span></th>
                <th class="border-b-0 font-normal p-0 xl:w-36 mg-banded-primary" scope="col"><span class="px-4 py-2 block">Current Market Year ({{marketDataSettings.current_market_year_label}})</span></th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(val, key, index) in sortedMarketInfo" :key="index" class="border-0 tracking-medium text-sm md:text-base" v-if="isCommodity(key) && displayRow(key)" :class="[
            {'mg-table-market-data-interactive__all-row': index == 0}]">
                <td class="p-0 hidden xl:table-cell relative button-cell md-chart-wrapper__label-cell" :style="{'background-color': getCommodityProperty({key: key, property: 'color'})}">
                    <div class="cell-inner-wrap">
                        <button @click="trigger(key)" :class="[{active: activeCommodities.indexOf(key) > -1}]" class="plain-button rounded-none antialiased text-left cell-inner p-2 absolute pin flex items-center button-cell__button">
                            <svg :class="[{'filter-shadow-sm': activeCommodities.indexOf(key) > -1}, {'mg-color-accent-2': activeCommodities.indexOf(key) == -1}]" class="mg-icon mg-icon--medium button-cell__mg-icon absolute">
                                <use :href='"#" + getCommodityProperty({key: key, property: "icon"})' :xlink:href='"#" + getCommodityProperty({key: key, property: "icon"})' />
                            </svg>
                            <span :class="[{'text-shadow-sm': activeCommodities.indexOf(key) > -1}]" class="text-base leading-none font-bold" v-html="getCommodityProperty({key: key, property: 'text'})"></span>
                        </button>
                    </div>
                </td>
                <td class="p-0 border-l-8 border-r-8 mg-border-primary-darker align-bottom">
                    <div class="cell-inner p-2">
                        <div v-if="!isUsdaAllRow(key)">
                            {{formatNumber(val.previous_market_year_quantity)}}
                        </div>
                        <div>
                            ${{formatNumber(val.previous_market_year_value)}}
                        </div>
                    </div>
                </td>
                <td class="p-0 border-l-8 border-r-8 mg-border-primary">
                    <div class="cell-inner p-2 relative">
                        <div :class="{'pr-8': !isUsdaAllRow(key), 'text-right': isUsdaAllRow(key)}" class="md-chart-wrapper__change-wrap">
                            <div class="pin-t pin-r mt-1 text-xs md-chart-wrapper__change-content" :class="{'success-color': val.change > 0, 'error-color': val.change <= 0, 'absolute': !isUsdaAllRow(key), 'mr-1': !isUsdaAllRow(key)}">
                                <svg v-if="getPercent(val.change) != 'N/A'" class="mg-icon">
                                    <use :href="getArrowName(val.change)" :xlink:href="getArrowName(val.change)" />
                                </svg> {{getPercent(val.change)}}
                            </div>
                            <div v-if="!isUsdaAllRow(key)">{{formatNumber(val.current_market_year_quantity)}}</div>
                        </div>
                        <div>
                            ${{formatNumber(val.current_market_year_value)}}
                        </div>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>   
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";

import formatNumber from "../utilities/format-number";
import getArrowName from "../utilities/get-svg-arrow-name";
import getPercent from "../utilities/get-percent";

export default {
    props: ["data"],
    name: "market-data-commodities",
    computed: {
        ...mapState([
            "isDesktop",
            "showQty",
            "marketDataMode",
            "commodities",
            "activeCommodities",
            "activeMarket",
            "marketDataSettings"
        ]),
        ...mapGetters(["getCommodityProperty", "isCommodity", "sortedData"]),
        sortedMarketInfo() {
            return this.sortedData(this.data);
        }
    },
    methods: {
        ...mapMutations([
            "addActiveCommodity",
            "removeActiveCommodity",
            "deactivateAllCommodities"
        ]),
        ...mapActions(["activateSingleCommodity"]),
        formatNumber: formatNumber,
        getArrowName: getArrowName,
        getPercent: getPercent,
        displayRow(key) {
            if (!this.isDesktop && this.activeCommodities.indexOf(key) == -1) {
                return false;
            } else {
                return true;
            }
        },
        isUsdaAllRow(key) {
            return key === "all" && this.marketDataMode == "USDA-data";
        },
        trigger(key) {
            if (this.showQty && this.marketDataMode == "USDA-data") {
                this.activateSingleCommodity(key);
            } else {
                const keyActiveIndex = this.activeCommodities.indexOf(key);
                if (keyActiveIndex > -1) {
                    this.removeActiveCommodity(keyActiveIndex);
                } else {
                    this.addActiveCommodity(key);
                }
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/js/vue-components/market-data-commodities.vue